/** Séparateur unique : sujet à gauche, marque à droite. */
export const SEO_BRAND = 'PostDev'
export const SEO_BRAND_SUFFIX = ` | ${SEO_BRAND}`

/** Seule exception : l’accueil met la marque en premier. */
export const HOME_TITLE =
  'PostDev | Agence de solutions digitales — Lillers, Hauts-de-France'

export function withBrandTitle(subject: string): string {
  const clean = String(subject || '')
    .replace(/\s+/g, ' ')
    .trim()
  if (!clean) return SEO_BRAND
  if (clean === SEO_BRAND || clean === HOME_TITLE) return clean
  if (clean.endsWith(SEO_BRAND_SUFFIX)) return clean
  return `${clean}${SEO_BRAND_SUFFIX}`
}
